import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { UtilsService } from '../../../sharedServices/utils.service';

@Component({
  selector: 'app-mu-form-password',
  templateUrl: './mu-form-password.component.html',
  styleUrls: ['./mu-form-password.component.sass'],
})
export class MuFormPasswordComponent implements OnInit {
  @Input() field: string;
  @Input() formGroup: UntypedFormGroup;
  @Input() checkPassword: boolean;
  @Input() passwordCheckerField: string;
  @Input() passwordCheckerName: string;
  @Input() passwordCheckerParams: { [key: string]: string };
  @HostBinding('class') baseClass: string;

  constructor(public utils: UtilsService) {
    /** */
  }

/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
  ngOnInit(): void {
    /** */
  }
/* eslint-enable @angular-eslint/no-empty-lifecycle-method */
}
